import { queryOptions } from '@tanstack/react-query';

import { type Breadcrumb } from './types';

import { RQ_CATEGORY_BREADCRUMBS } from '@/modules/ReactQuery/cacheKeys';
import { buildCategoryBreadcrumbQueryParams } from '@/modules/breadcrumbs/helpers';
import { fetchCategoryBreadcrumbs } from '@/modules/search/api';

export function categoryBreadcrumbsQueryOptions({
  categoryPathname = '/category',
  linkPrefix,
  enabled = true,
}: {
  categoryPathname: string;
  linkPrefix?: string;
  enabled?: boolean;
}) {
  const params = buildCategoryBreadcrumbQueryParams(categoryPathname);
  const hasParams = Boolean(
    params.gender ||
    params.group ||
    params.product_type ||
    params.is_kids === 'true'
  );

  return queryOptions({
    queryKey: [RQ_CATEGORY_BREADCRUMBS, params],
    queryFn: async () => {
      const { data } = await fetchCategoryBreadcrumbs(params);

      return data;
    },
    enabled: enabled && hasParams,
    select: (data: Breadcrumb[]) => {
      if (linkPrefix) {
        return data.map(({ link, ...rest }: Breadcrumb) => ({
          ...rest,
          link: link ? `${linkPrefix}${link}` : link,
        }));
      }
      return data;
    },
  });
}
